const ACTIVATE_PLATFORM_OWNER_URL =
  "https://us-central1-manucalc-1d2b5.cloudfunctions.net/activatePlatformOwner";

export const ensurePlatformOwnerClaim = async (user, currentTokenResult) => {
  if (!user?.uid) return false;
  if (currentTokenResult?.claims?.platformOwner === true) return true;

  const idToken = await user.getIdToken();
  const response = await fetch(ACTIVATE_PLATFORM_OWNER_URL, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
  });

  if (response.status === 403) return false;
  if (!response.ok) {
    throw new Error("Platform-owner access could not be activated.");
  }

  const refreshedToken = await user.getIdTokenResult(true);
  return refreshedToken.claims.platformOwner === true;
};
